import React from "react";
import "./partners-page.scss"

import MC from "./img/brand_master_card.svg"
import Portmone from "./img/brand_portmone.svg"
import Ipay from "./img/brand_ipay.png"
import EasyPay from "./img/brand_easy_pay.png"
import { useTranslation } from "react-i18next";

const ArrayImg = [MC,Portmone,Ipay,EasyPay]

export function PaymentSystems(){
    const {t} = useTranslation()
    return(
        <div className="partner-info">
            <h1 className="partner-info_title">{t(`partners-points-of-sales.title`)}</h1>
            {
                ArrayImg.map((el,index)=>{
                    return(
                        <div className="partner-info-case" key={index}>
                            <img className="partner-info-case_img" src={el} alt="" />
                            <div className="partner-info-case_inform">
                                <h1>{t(`payment-systems.info.${index}.0`)}</h1>
                                <span>{t(`payment-systems.info.${index}.1`)}</span>
                                <a href={t(`payment-systems.info.${index}.2`)}>{t(`partners-points-of-sales.info.${index}.2`)}</a>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}